import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import CanvasPreview from "@/components/CanvasPreview";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Templates() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState(null);
  const [busy, setBusy] = useState(null);

  useEffect(() => { api.get("/templates").then((r) => setTemplates(r.data)).catch(() => setTemplates([])); }, []);

  const use = async (t) => {
    setBusy(t.id);
    try {
      const { data } = await api.post("/designs", {
        name: t.name, width: t.width, height: t.height, background: t.background, elements: t.elements || [],
      });
      navigate(`/editor/${data.id}`);
    } catch (e) { toast.error("Could not open template"); setBusy(null); }
  };

  return (
    <div className="flex bg-kann-base min-h-screen">
      <Sidebar />
      <main className="flex-1 min-w-0 p-4 md:p-10 pt-16 md:pt-10 relative">
        <div className="absolute inset-0 -z-10 bg-dots overflow-hidden"><div className="glow-orb" style={{ width: 640, height: 640, top: -120, left: "50%" }} /></div>
        <div className="text-xs tracking-[0.3em] uppercase text-kann-gold font-mono">Start faster</div>
        <h1 className="text-3xl sm:text-4xl font-medium text-kann-text-pri mt-2">Templates</h1>
        <p className="font-light text-kann-text-sec mt-2">Pick a layout and make it yours in seconds.</p>

        {templates === null ? (
          <div className="flex items-center justify-center py-20"><Loader2 className="w-6 h-6 text-kann-gold animate-spin" /></div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 mt-8" data-testid="templates-grid">
            {templates.map((t) => (
              <div key={t.id} data-testid={`template-card-${t.id}`}
                className="group bg-kann-surface border border-kann-border/30 rounded-lg overflow-hidden hover:border-kann-gold/60 transition-colors">
                <div className="w-full aspect-[4/5] bg-kann-base flex items-center justify-center overflow-hidden">
                  <CanvasPreview design={t} targetWidth={220} />
                </div>
                <div className="p-3 flex items-center justify-between gap-2">
                  <span className="text-sm text-kann-text-pri truncate">{t.name}</span>
                  <button onClick={() => use(t)} disabled={busy === t.id} data-testid={`use-template-${t.id}`}
                    className="text-xs font-semibold bg-kann-ink text-white px-3 py-1.5 rounded-full hover:bg-black transition-colors flex items-center gap-1">
                    {busy === t.id ? <Loader2 className="w-3 h-3 animate-spin" /> : "Use"}
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
